/**
 * Updates retail price display when variant changes.
 * Requires variant metafields to be exposed via JSON.
 */
(function () {
  const SELECTOR = '[data-retail-price]';

  function formatMoney(cents) {
    // cents is in cents (e.g. 165000), representing Shopify standard money values
    const valueNum = parseFloat(cents) / 100;
    const formattedValue = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valueNum).replace(/,/g, ''); // "3500", matches snippets/format-money.liquid

    if (document.documentElement.lang === 'ar') {
      return formattedValue + ' درهم';
    }
    return formattedValue + ' Dhs';
  }

  function updateRetailPrice(container, variant) {
    const dataEl = container.querySelector('[data-retail-prices]');
    if (!dataEl) return;

    try {
      const prices = JSON.parse(dataEl.textContent);
      const retailPrice = prices[variant.id];

      const row = container.closest('.retail-price-purchase-item, .retail-price-pill-group, .retail-price-comparison') || container;

      if (retailPrice) {
        const retailAmount = parseFloat(retailPrice);
        const amountEl = container.querySelector('[data-retail-amount]');
        if (amountEl) {
          amountEl.textContent = formatMoney(retailAmount);
        }
        row.style.display = '';
      } else {
        row.style.display = 'none';
      }
    } catch (e) {
      console.warn('Retail price update failed:', e);
    }
  }

  document.addEventListener('variant:changed', function (event) {
    const variant = event.detail.variant;
    if (!variant) return;

    // Scope to the closest product-info or card component
    const productContainer = event.target.closest('product-info, .card-wrapper, .product-card-wrapper, .quick-add-modal__content');
    if (!productContainer) return;

    const container = productContainer.querySelector(SELECTOR);
    if (!container) return;

    updateRetailPrice(container, variant);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event.data.variant;
      if (!variant) return;

      const sectionId = event.data.sectionId;
      const productContainers = document.querySelectorAll(`product-info[data-section="${sectionId}"], [data-section="${sectionId}"] product-info`);
      
      productContainers.forEach((productContainer) => {
        const container = productContainer.querySelector(SELECTOR);
        if (container) {
          updateRetailPrice(container, variant);
        }
      });
    });
  }
})();
